import React, { Fragment } from "react";

import styles from "./UserDataSummary.module.sass";
import TitleSection from "../TitleSection/TitleSection";
import dateUtils from "../../utils/date";
import masks from "../../utils/masks";

const userDataSummary = props => {
  return (
    <Fragment>
      <TitleSection
        title={
          props.data.selectedIdentifier === "cpf"
            ? "Seus dados"
            : "Dados da empresa"
        }
      />
      <div className={styles.dataSummary}>
        <div className={styles.dataItem}>
          <span className={styles.placeholder}>
            {
              props.data.selectedIdentifier === "cpf"
              ? "Nome completo"
              : "Razão social"
            }
          </span>
          <p className={styles.dataDesc}>{props.data.client.pessoa.nome}</p>
        </div>

        <div className={styles.dataItem}>
          <span className={styles.placeholder}>
            {
               props.data.selectedIdentifier === "cpf"
                ? "CPF"
                : "CNPJ"
            }
          </span>
          <p className={styles.dataDesc}>{
              props.data.selectedIdentifier === "cpf"
                ? masks.cpf(props.data.document)
                : masks.cnpj(props.data.document)
            }</p>
        </div>
        <div className={styles.dataItem}>
          <span className={styles.placeholder}>
            {
              props.data.selectedIdentifier === "cpf"
                ? "Data de nascimento"
                : "Data de fundação"
            }
          </span>
          <p className={styles.dataDesc}>{
              props.data.selectedIdentifier === "cpf"
                ? dateUtils.format(
                    new Date(
                      props.data.client.pessoa.dadosPessoaFisica.dataNascimento
                    )
                  )
                : dateUtils.format(
                    new Date(
                      props.data.client.pessoa.dadosPessoaJuridica.dataFundacao
                    )
                  )
            }</p>
        </div>

        </div>
    </Fragment>
  );
};

export default userDataSummary;
